<template>
  <div class="logo-container"
       :style="{
            width: this.skin.sideBarWidth,
            height: this.skin.topNavHeight,
            'line-height': this.skin.topNavHeight,
            'background-color': this.$store.getters.theme}" >
    <h2 class="content" v-if="!$store.getters.topNav && sidebar.collapsed">
      <img :src="logo" class="logo"/>
    </h2>
    <h2 class="content" v-else>
      <img :src="logo" class="logo"/>
      <span class="ml10">{{ title }}</span>
    </h2>
  </div>
</template>
<script>
import logoImg from '@/assets/img/logo.png'
import {mapState} from "vuex";
const defaultSettings = require('@/settings.js')

export default {
  name: 'Logo',
  data() {
    return {
      logo: logoImg,
      title: defaultSettings.title,
    }
  },
  computed: {
    ...mapState({
      skin: state => state.app.skin,
      sidebar: state => state.app.sidebar,
    }),
    app() {
      return this.$store.state.app;
    },
  },
  methods: {}
}
</script>

<style scoped lang="less">
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    color: #f1f1f1;
    font-weight: 600;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .logo {
    width: 30px;
    height: 30px;
  }

}

.hidden {
  display: none;
}
</style>
